var QueueModel = require("../models/QueueModel");
var QueueMessagesWS = require("../ws/QueueMessagesWS");
var AbstractWS = require("./AbstractWS");
var VirtualScrollQueue = require("../helpers/VirtualScrollQueue");
var xmlToJson = require("../helpers/xmlToJson");

function QueuesWS(viewModel) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.queues = ko.observableArray([]);
  self.name = 'QueueWS';
  this.isFirstRun = ko.observable(true);
  self.serviceURL = ko.pureComputed(self._serviceURL.bind(self));
  self.queueIds = ko.pureComputed(self.allQueueIds.bind(self));

  return self;

};

QueuesWS.prototype = Object.create(AbstractWS.prototype);
QueuesWS.prototype.constructor = QueuesWS;

/**
 * Locates a Consumer by their ticket number
 * supports barcode scanning
 *
 * @param {String} ticket
 * @return {SpotModel}
 */
QueuesWS.prototype.findConsumerByTicket = function (ticket) {
  var obj = {};
  var spot = null;
  var self = this;

  self.queues().forEach(function (queue) {
    // If a spot has already been found, no need to
    // look through other queues. forEach does not provide
    // a break method, so this is the best closest alternative
    if (!obj.spot) {
      // See if the consumer is found in the currently servicing customers
      if (self.parent.currentlyServicing().length > 0) {
        self.parent.currentlyServicing().forEach(function (servicing) {

          if (servicing.spot.receiptNumber == ticket) {
            spot = [servicing.spot];

            obj.spot = spot[0];
            obj.place = spot ? 'servicing' : null;
          }
        });
      }

      if (!obj.spot) {
        // Look for the consumers in the list of waiting consumers
        spot = queue.spots().filter(function (c) {
          // Find any waiting consumers that have the same ticket
          // and are not waiting to be checked in
          return c.receiptNumber == ticket && !c.callAhead;
        });

        obj.spot = spot[0];
        obj.place = spot ? 'queued' : null;
      }


      // If the consumer was not found in the list of waiting customers
      // look in the summoned list of consumers
      if (!obj.spot) {
        spot = queue.tickets().filter(function (c) {
          return c.receiptNumber == ticket;
        });

        obj.spot = spot[0];
        obj.place = spot ? 'summoned' : null;
      }
    }
  });

  return obj;
};


/**
 * Returns the name of the queue with the matching ID
 *
 * @param {Number} id
 * @returns {String}
 */
QueuesWS.prototype.getNameById = function (id) {
  var q = this.getQueueById(id)
  return (q) ? q.description : '';
};


/**
 * Finds a queue by the provided ID
 *
 * @param {Number} iId
 * @returns {QueueModel | Null}
 */
QueuesWS.prototype.getQueueById = function (iId) {
  return this.queues().find(function (queue) {
    return queue.id == Number(iId);
  });
};

/**
 * Collect IDs from queues and return them as an array
 *
 * @returns {Array}
 */
QueuesWS.prototype.allQueueIds = function() {
  return this.queues().reduce(function (arr, queue) {
    arr.push(queue.id);
    return arr;
  }, []);
}

/**
 * This method iterates over the data returned from the service and
 * converts the individual nodes into LocationModels and then assigns
 * them to this object's locations collection.
 *
 * @param {XMLString} xmlData XML data returned from the service
 * @returns {LocationsWS} Returns the object as chainable, for best practice
 */
QueuesWS.prototype.processData = function (xmlData) {
  var self = this;
  // Call the superclass method to perform any core actions
  AbstractWS.prototype.processData.call(self, xmlData);

  var json = xmlToJson.parse(xmlData);

  if (json.queues) {
    var queues = Array.makeArray(json.queues.queue);
    var queueModels = [];

    queues.forEach(function (queueData) {
      var queueMessagesWS = new QueueMessagesWS(self.parent)
      var queue = new VirtualScrollQueue(new QueueModel(queueData, queueMessagesWS.get, self.parent.userLang));
      queueMessagesWS.doRequest(null, queue.id);
      queueModels.push(queue);
    });

    self.queues(queueModels);

    // Queues should update before firstRun updates
    // If it changes before then the code to restore the previously selected Queues won't work at all.
    if (this.isFirstRun()) {
      this.isFirstRun(false);
    }
  }

  return self;
};


/**
 * Returns the object to it's initial state
 *
 * @returns none
 */
QueuesWS.prototype._reset = function () {
  var self = this;
  // Remove any queues
  self.queues.removeAll();
  self.isFirstRun(true);
  // Call the superclass method to perform any core actions
  AbstractWS.prototype.reset.call(self);
};


/**
 * Defines the string to request API services
 *
 * @returns {String}
 */
QueuesWS.prototype._serviceURL = function () {
  return '/qless/api/v1/employee/locations/' + this.parent.selectedLocationIds().join(',') + '/queues';
};

/**
 * Default Country Code for given Queues
 * @param {number[]} ids queue ids
 * @returns 
 */
QueuesWS.prototype.defaultCountryCode = function (ids) {
  return ids.reduce(function (lastCountryCode, id) {
    var queue = this.getQueueById(id);
    var defaultPhoneCountryCode = queue.defaultPhoneCountryCode()

    return (defaultPhoneCountryCode) ? defaultPhoneCountryCode : lastCountryCode
  }.bind(this), null);
} 

module.exports = QueuesWS
